import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { selectors, actions } from 'builder/modules/careerProfile'
import { FetchStatuses } from 'builder/modules/constants'
import { useIsCareerProfileAvailable } from './useIsCareerProfileAvailable'

export const useCareerProfileData = (isForceDisabled?: boolean) => {
  const dispatch = useDispatch()
  const isAvailable = useIsCareerProfileAvailable()
  const shouldInit = isAvailable && !isForceDisabled
  const fetchStatus = useTypedSelector(selectors.fetchCareerProfileStatus)
  const careerProfileData = useTypedSelector(selectors.careerProfileData)
  const isCareerProfileLoading = fetchStatus === FetchStatuses.loading

  useEffect(() => {
    if (shouldInit && fetchStatus === FetchStatuses.notAsked) {
      dispatch(actions.fetchCareerProfile())
    }
  }, [shouldInit, fetchStatus, dispatch])

  return { careerProfileData, isCareerProfileLoading }
}
